import { render, staticRenderFns } from "./ProgramRewardWidget.vue?vue&type=template&id=7fbba492&scoped=true"
import script from "./ProgramRewardWidget.vue?vue&type=script&lang=js"
export * from "./ProgramRewardWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgramRewardWidget.vue?vue&type=style&index=0&id=7fbba492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbba492",
  null
  
)

export default component.exports